import axios from 'axios'
import URL from '@/constants/url'
import * as Sentry from '@sentry/vue'
import { IS_ADMIN_APP } from '@/constants/envAppConfig'

const httpClient = axios.create({
    baseURL: URL.API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

// перехватчик ошибок
const errorInterceptor = error => {
    // если ошибка на сервере
    if (!error.response) {
        console.error('Network/Server error', error)
        return Promise.reject(error)
    }

    console.error(error.response.status, error.message)
    if (IS_ADMIN_APP && error.response.status === 401) {
        // Reload through the protected admin ingress. It starts the SSO flow
        // when the oauth2-proxy session has expired.
        window.location.assign(window.location.href)
        return Promise.reject(error)
    }

    // разбираем коды ответа
    if ((error.response.status < 400) || (error.response.status >= 500)) {
        Sentry.captureException(error)
    }
    return Promise.reject(error)
}

// Interceptor for responses
const responseInterceptor = response => {
    switch (response.status) {
        case 200:
        // все ок
            break
        // todo
        default:
        // todo
    }

    return response
}

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor)

export default httpClient
